import React, { FC, memo } from 'react';
import { TouchableOpacity, TouchableOpacityProps } from 'react-native';

import { DEFAULT_TOUCH_ACTIVE_OPACITY } from '../Settings';

const CustomTouchableOpacity: FC<TouchableOpacityProps> = (props) => {
  const { activeOpacity = DEFAULT_TOUCH_ACTIVE_OPACITY, ...restProps } = props;

  return <TouchableOpacity {...restProps} activeOpacity={activeOpacity} />;
};

export default memo(CustomTouchableOpacity);
